import { Component, createRef, createElement } from 'react';
import { ProTable as OriginalProTable, } from '@ant-design/pro-components';
import { Tag, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { defineGetterProperties, isPlainObj } from '../../shared/index';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
class ProTable extends Component {
    // pro-table 未对批量操作进行封装，自己封了
    state = {
        selectedRowKeys: this.props.rowSelection?.selectedRowKeys ?? [],
        collapsed: this.props.search === false ? undefined : this.props.search?.defaultCollapsed, // 之前设置的this.props.search.collapsed会失效，但问题不大
    };
    actionRef = createRef();
    formRef = createRef();
    onSelectRowsChange = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys,
        });
    };
    getSelectedRowKeys() {
        return this.state.selectedRowKeys;
    }
    setSelectedRowKeys(selectedRowKeys) {
        this.setState({
            selectedRowKeys: Array.isArray(selectedRowKeys) ? selectedRowKeys : [selectedRowKeys],
        });
    }
    componentDidMount() {
        // 把操作方法挂载到 class instance 上，可通过 this.$ 调用
        defineGetterProperties(this, [this.actionRef, this.formRef]);
    }
    render() {
        ConfigProvider.config({
            theme: {
                primaryColor: '#f16622',
            },
        });
        const { columns, rowSelection } = this.props;
        const { selectedRowKeys, collapsed } = this.state;
        // 劫持渲染标签类型的列
        columns?.map((item) => {
            if (isPlainObj(item.valueEnum) && item.renderTag === true) {
                item.render = (_, record) => {
                    const colValue = record[item.dataIndex];
                    const target = item.valueEnum[colValue];
                    return target?.text ? (createElement(Tag, { color: target?.status?.toLowerCase() }, target?.text)) : ('-');
                };
            }
        });
        const pagination = this.props.pagination;
        // current 让用户自己配置的话，用户需要自己监听 onChange 事件去修改，对低代码平台不友好
        if (typeof pagination?.current === 'number') {
            delete pagination.current;
        }
        if (typeof pagination?.total === 'number') {
            delete pagination.total;
        }
        return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
            createElement(OriginalProTable, { ...this.props, search: typeof this.props.search === 'boolean'
                    ? this.props.search
                    : {
                        ...this.props.search,
                        collapsed,
                        onCollapse: () => {
                            if (this.props.search === false)
                                return;
                            this.setState({
                                collapsed: !collapsed,
                            });
                            if (this.props.search.onCollapse) {
                                // 如果设置了函数则继续执行
                                this.props.search.onCollapse(!collapsed);
                            }
                        },
                    }, rowSelection: rowSelection
                    ? {
                        ...rowSelection,
                        defaultSelectedRowKeys: selectedRowKeys,
                        selectedRowKeys,
                        onChange: (...args) => {
                            rowSelection?.onChange?.(...args);
                            this.onSelectRowsChange(...args);
                        },
                    }
                    : false, columns: columns, actionRef: this.actionRef, formRef: this.formRef })));
    }
}
export default ProTable;
